import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, authHeadersOnly } from '../services/apiConfig';
import './Notifications.css';

function Notifications({ userId, onClose, isDropdown = false }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${API}/api/notifications/user/${userId}`, { headers: authHeadersOnly() });
      setNotifications(response.data);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      await axios.put(`${API}/api/notifications/${id}/read`, {}, { headers: authHeadersOnly() });
      fetchNotifications();
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      await axios.put(`${API}/api/notifications/user/${userId}/read-all`, {}, { headers: authHeadersOnly() });
      fetchNotifications();
    } catch (error) {
      console.error('Error marking all as read:', error);
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'ORDER': return '📦';
      case 'PRODUCT': return '🎁';
      case 'PROMOTION': return '🎉';
      case 'QUERY': return '📬';
      default: return '🔔';
    }
  };

  const formatTime = (dateTime) => {
    if (!dateTime) return '';
    // Server returns UTC, append Z if missing
    const utcStr = dateTime.endsWith('Z') ? dateTime : dateTime + 'Z';
    const date = new Date(utcStr);
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);
    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  };

  return (
    <div className={isDropdown ? "notifications-dropdown" : "notifications-overlay"} onClick={!isDropdown ? onClose : undefined}>
      <div className={isDropdown ? "notifications-dropdown-content" : "notifications-modal"} onClick={(e) => e.stopPropagation()}>
        <div className={isDropdown ? "notifications-dropdown-header" : "notifications-header"}>
          <h2>Notifications</h2>
          <div className="header-actions">
            {notifications.some(n => !n.isRead) && (
              <button className="mark-all-btn" onClick={handleMarkAllAsRead}>
                Mark all as read
              </button>
            )}
            <button
              onClick={onClose}
              aria-label="Close notifications"
              style={{
                background: '#f5f5f5',
                border: 'none',
                fontSize: '22px',
                color: '#111',
                cursor: 'pointer',
                width: '36px',
                height: '36px',
                minWidth: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                fontWeight: '700',
                flexShrink: 0,
                lineHeight: 1,
                opacity: 1,
                visibility: 'visible',
              }}
            >×</button>
          </div>
        </div>

        <div className="notifications-content">
          {loading ? (
            <div className="loading">Loading notifications...</div>
          ) : notifications.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🔔</div>
              <p>No notifications yet</p>
            </div>
          ) : (
            <div className="notifications-list">
              {notifications.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${!notification.isRead ? 'unread' : ''}`}
                  onClick={() => !notification.isRead && handleMarkAsRead(notification.id)}
                >
                  <div className="notification-icon">{getIcon(notification.type)}</div>
                  <div className="notification-content">
                    <h4>{notification.title}</h4>
                    <p>{notification.message}</p>
                    <span className="notification-time">{formatTime(notification.createdAt)}</span>
                  </div>
                  {!notification.isRead && <div className="unread-dot"></div>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Notifications;
